import { render, staticRenderFns } from "./recommend-feedback.vue?vue&type=template&id=484923c4"
import script from "./recommend-feedback.vue?vue&type=script&lang=js"
export * from "./recommend-feedback.vue?vue&type=script&lang=js"
import style0 from "./recommend-feedback.vue?vue&type=style&index=0&id=484923c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports